import React, { createContext, useContext, useState, useEffect } from 'react';
import { essLogin } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('ess_user');
    const storedEmployee = localStorage.getItem('ess_employee');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    if (storedEmployee) {
      setEmployee(JSON.parse(storedEmployee));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await essLogin(email, password);
      const { token, user: userData, employee: empData } = response;
      
      localStorage.setItem('ess_token', token);
      localStorage.setItem('ess_user', JSON.stringify(userData));
      
      // If no employee record found, create a virtual one from user data
      const effectiveEmployee = empData || {
        id: userData.id,
        navn: userData.email.split('@')[0],
        epost: userData.email,
        email: userData.email,
        isVirtual: true
      };
      
      localStorage.setItem('ess_employee', JSON.stringify(effectiveEmployee));
      setEmployee(effectiveEmployee);
      setUser(userData);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || error.response?.data?.message || 'Login failed' };
    }
  };

  const logout = () => {
    localStorage.removeItem('ess_token');
    localStorage.removeItem('ess_user');
    localStorage.removeItem('ess_employee');
    setUser(null);
    setEmployee(null);
  };

  return (
    <AuthContext.Provider value={{ user, employee, loading, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};